import ConsentConfigProvider from './ConsentConfigProvider'

export default ConsentConfigProvider

export { useConsentConfig } from './ConsentConfigContext'

